import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import networkRulesService from '../../services/api/networkRulesService';

export const fetchRuleSets = createAsyncThunk('networkRules/fetchRuleSets', async () => {
  return networkRulesService.getRuleSets();
});

export const fetchRuleSet = createAsyncThunk('networkRules/fetchRuleSet', async (id) => {
  return networkRulesService.getRuleSet(id);
});

export const createRuleSet = createAsyncThunk('networkRules/createRuleSet', async (data) => {
  return networkRulesService.createRuleSet(data);
});

export const fetchRules = createAsyncThunk('networkRules/fetchRules', async (params) => {
  return networkRulesService.getRules(params);
});

export const createRule = createAsyncThunk('networkRules/createRule', async (data) => {
  return networkRulesService.createRule(data);
});

export const updateRule = createAsyncThunk('networkRules/updateRule', async ({ id, data }) => {
  return networkRulesService.updateRule(id, data);
});

export const deleteRule = createAsyncThunk('networkRules/deleteRule', async (id) => {
  await networkRulesService.deleteRule(id);
  return id;
});

export const importRules = createAsyncThunk('networkRules/importRules', async (data) => {
  return networkRulesService.importRules(data);
});

export const seedDefaultRules = createAsyncThunk('networkRules/seed', async () => {
  return networkRulesService.seed();
});

const networkRulesSlice = createSlice({
  name: 'networkRules',
  initialState: {
    ruleSets: [],
    currentRuleSet: null,
    rules: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearCurrentRuleSet: (state) => {
      state.currentRuleSet = null;
      state.rules = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Rule Sets
      .addCase(fetchRuleSets.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchRuleSets.fulfilled, (state, action) => { state.loading = false; state.ruleSets = action.payload; })
      .addCase(fetchRuleSets.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })

      .addCase(fetchRuleSet.pending, (state) => { state.loading = true; })
      .addCase(fetchRuleSet.fulfilled, (state, action) => {
        state.loading = false;
        state.currentRuleSet = action.payload;
        state.rules = action.payload.rules || [];
      })
      .addCase(fetchRuleSet.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })

      .addCase(createRuleSet.fulfilled, (state, action) => {
        state.ruleSets.unshift(action.payload);
      })

      // Rules
      .addCase(fetchRules.fulfilled, (state, action) => { state.rules = action.payload; })

      .addCase(createRule.fulfilled, (state, action) => {
        state.rules.unshift(action.payload);
      })

      .addCase(updateRule.fulfilled, (state, action) => {
        const idx = state.rules.findIndex((r) => r.id === action.payload.id);
        if (idx !== -1) state.rules[idx] = action.payload;
      })

      .addCase(deleteRule.fulfilled, (state, action) => {
        state.rules = state.rules.filter((r) => r.id !== action.payload);
      })

      // Import
      .addCase(importRules.fulfilled, (state, action) => {
        if (action.payload.ruleSet) {
          const exists = state.ruleSets.find((s) => s.id === action.payload.ruleSet.id);
          if (!exists) state.ruleSets.unshift(action.payload.ruleSet);
        }
      })

      // Seed
      .addCase(seedDefaultRules.fulfilled, (state, action) => {
        const exists = state.ruleSets.find((s) => s.id === action.payload.id);
        if (!exists) state.ruleSets.unshift(action.payload);
      });
  },
});

export const { clearCurrentRuleSet } = networkRulesSlice.actions;
export default networkRulesSlice.reducer;
